import * as Yup from "yup";
import { arrayToPattern, PHONE_NUMBER_PATTERN } from "@eave/shared/utils/regex-patterns";
import { HLHLContactBranch, HLHLContactRole, HLHLContactSource } from "@eave/shared/types/api";

const roleIsInternal = (r: HLHLContactRole): boolean =>
  [
    HLHLContactRole.CashClose,
    HLHLContactRole.CashCloseAdmin,
    HLHLContactRole.LoanOfficerAssistant,
    HLHLContactRole.QualityControl,
    HLHLContactRole.SettlementAgent,
  ].includes(r);

export const validationSchema = Yup.object().shape({
  first_name: Yup.string().required(),
  middle_name: Yup.string().nullable(),
  last_name: Yup.string().required(),
  suffix: Yup.string().nullable(),
  personalized_signup_link_fragment: Yup.string()
    .when("role", {
      is: HLHLContactRole.LoanOfficer,
      then: Yup.string().required(),
      otherwise: Yup.string().nullable(),
    })
    .matches(/^[a-zA-Z]*$/, "must contain only uppercase or lowercase letters"),
  preferred_first_name: Yup.string().when("role", {
    is: HLHLContactRole.LoanOfficer,
    then: Yup.string().required(),
    otherwise: Yup.string().nullable(),
  }),
  email: Yup.string().email().required(),
  role: Yup.string()
    .matches(arrayToPattern(Object.values(HLHLContactRole)))
    .required(),
  phone: Yup.string().when("role", {
    is: (r: HLHLContactRole) => !roleIsInternal(r),
    then: Yup.string()
      .matches(PHONE_NUMBER_PATTERN, "Please enter a valid phone number.")
      .required(),
    otherwise: Yup.string().nullable(),
  }),
  branch: Yup.string().when("role", {
    is: roleIsInternal,
    then: Yup.string().nullable(),
    otherwise: Yup.string()
      .matches(arrayToPattern(Object.values(HLHLContactBranch)))
      .required(),
  }),
  source: Yup.string().when("role", {
    is: (r: HLHLContactRole) => !roleIsInternal(r),
    then: Yup.string()
      .matches(arrayToPattern(Object.values(HLHLContactSource)))
      .required(),
    otherwise: Yup.string().nullable(),
  }),
  nmls_id: Yup.string().when("role", {
    is: HLHLContactRole.LoanOfficer,
    then: Yup.string().required(),
    otherwise: Yup.string().nullable(),
  }),
  nmls_licensed_states: Yup.string().nullable(),
  slack_id: Yup.string().when("default_slack_notify", {
    is: true,
    then: Yup.string().required(),
    otherwise: Yup.string().nullable(),
  }),
  default_slack_notify: Yup.boolean(),
});

export const initialValues = {
  id: 0,
  first_name: "",
  middle_name: "",
  last_name: "",
  suffix: "",
  preferred_first_name: "",
  email: "",
  role: "" as HLHLContactRole,
  phone: "",
  branch: "" as HLHLContactBranch,
  source: "" as HLHLContactSource,
  nmls_id: "",
  nmls_licensed_states: "",
  slack_id: "",
  default_slack_notify: false,
  active: true,
};
